import { useEffect, useRef, useState } from 'react'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { SECOND_MS } from '$func/time'

export function useCounterFromDate({
  dateMS,
  stop,
  intervalMS = SECOND_MS,
}: {
  dateMS?: number
  stop?: boolean
  intervalMS?: number
}) {
  const dateRef = useRef(dateMS || dateWithOffset())
  const intervalRef = useRef<NodeJS.Timeout>()
  const [diff, setDiff] = useState(dateWithOffset() - dateRef.current)

  useEffect(() => {
    if (stop) {
      clearInterval(intervalRef.current)
    }
  }, [stop])

  useEffect(() => {
    setDiff(dateWithOffset() - dateRef.current)
    intervalRef.current = setInterval(() => {
      setDiff(dateWithOffset() - dateRef.current)
    }, intervalMS)

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [intervalMS])

  return diff
}
